import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCapsule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3.99057 13.6019C1.33648 10.9478 1.33648 6.64466 3.99057 3.99057C6.64466 1.33648 10.9478 1.33648 13.6019 3.99057L20.0094 10.3981C22.6635 13.0522 22.6635 17.3553 20.0094 20.0094C17.3553 22.6635 13.0522 22.6635 10.3981 20.0094L3.99057 13.6019Z",
			fill: "#9999A4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.80716 17.4186L6.55371 16.1651L7.04923 16.0697C7.04892 16.0698 7.0493 16.0697 7.05022 16.0695L7.06408 16.0665C7.07846 16.0633 7.10306 16.0577 7.13728 16.049C7.20572 16.0318 7.31261 16.0026 7.45319 15.9578C7.73439 15.868 8.15013 15.7152 8.66265 15.4682C9.68683 14.9746 11.1003 14.1036 12.6016 12.6023C14.1029 11.1009 14.9741 9.68737 15.4678 8.66305C15.7148 8.15047 15.8677 7.73465 15.9575 7.4534C16.0024 7.31279 16.0316 7.20588 16.0488 7.13741C16.0575 7.10318 16.0631 7.07858 16.0663 7.06419L16.0693 7.05036C16.0695 7.04945 16.0696 7.04903 16.0695 7.04934L16.165 6.55383L17.4184 7.80721C17.4085 7.83987 17.3978 7.87408 17.3864 7.9098C17.2769 8.2525 17.0988 8.7339 16.819 9.31431C16.2591 10.476 15.2936 12.0316 13.6623 13.6629C12.0309 15.2943 10.4754 16.2597 9.31384 16.8195C8.73348 17.0992 8.25214 17.2773 7.90946 17.3867C7.87385 17.398 7.83974 17.4087 7.80716 17.4186Z",
			fill: "#585863"
		})
	]
});
const ForwardRef = forwardRef(SvgCapsule);
export { ForwardRef as ReactComponent };
